import type { FC } from "react";

import type { User } from "../../../../core/types/fe/entities/user";
import type { ExtendedColumnsType } from "../../../index";
import { PropertyTable } from "../../../Table/components/PropertyTable";
import { Actions } from "../../../Table/types/types";
import type { AntCustomFormField, CommonFieldAttributes } from "../../types/types";
import { UserSelector } from "./UserSelector";

const getColumnsConfig = (t: Function): ExtendedColumnsType<User>[] => {
    return [
        {
            title: t("dataGroup.id"),
            key: "id",
            dataIndex: "id",
        },
        {
            title: t("dataGroups.createForm.usersTable.firstName"),
            key: "firstName",
            dataIndex: "firstName",
            editable: true,
        },
        {
            title: t("dataGroups.createForm.usersTable.lastName"),
            key: "lastName",
            dataIndex: "lastName",
            editable: true,
        },
        {
            title: t("common.username"),
            key: "username",
            dataIndex: "username",
        },
    ];
};

export interface DataGroupUsersTableProps extends AntCustomFormField<User[]>, CommonFieldAttributes {}

export const DataGroupIdmUsersTable: FC<DataGroupUsersTableProps> = ({ value = [], onChange }) => {
    const onDataChanged = (data: User[]) => {
        if (onChange) {
            onChange(data);
        }
    };

    const selector = <UserSelector key="selectUserToAdd" />;

    return (
        <PropertyTable<User>
            getColumnsConfig={getColumnsConfig}
            propertyAsRowKey="id"
            tableData={value}
            readOnly={false}
            elementSelector={selector}
            onDataChanged={onDataChanged}
            actions={[Actions.ADD, Actions.DELETE]}
        />
    );
};
